import "core-js/modules/es.array.find-index";
import "core-js/modules/es.object.define-property";
import { __decorate, __extends } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';

var RadioPage = function (_super) {
  __extends(RadioPage, _super);

  function RadioPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(RadioPage.prototype, "selectIndex", {
    get: function get() {
      var _this = this;

      return this.options.findIndex(function (item) {
        return item.option_id === _this.value;
      });
    },
    enumerable: false,
    configurable: true
  });

  RadioPage.prototype.handleClick = function (optionId) {
    this.$emit('input', optionId);
  };

  __decorate([Prop({
    type: Array,
    "default": []
  })], RadioPage.prototype, "options", void 0);

  __decorate([Prop({
    type: String,
    "default": ''
  })], RadioPage.prototype, "value", void 0);

  RadioPage = __decorate([Component({})], RadioPage);
  return RadioPage;
}(Vue);

export default RadioPage;